import { render, staticRenderFns } from "./AssignContainer.vue?vue&type=template&id=8866e63a&"
import script from "./AssignContainer.vue?vue&type=script&lang=js&"
export * from "./AssignContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports